import React from 'react';
import { Modal } from 'Components';
import Button from '../Button';
import styles from './ReportSavedModal.module.scss';

interface ReportSavedModalProps {
	visible: boolean;
	onClose: () => void;
	onViewSavedReports: () => void;
}

const ReportSavedModal: React.FC<ReportSavedModalProps> = ({
	visible,
	onClose,
	onViewSavedReports
}) => (
	<Modal
		className={styles.root}
		visible={visible}
		onCancel={onClose}
		centered
		size="xs"
		footer={
			<div className={styles.footer}>
				<Button variant="borderless" size="small" onClick={onClose}>
					Close
				</Button>
				<Button size="small" onClick={onViewSavedReports}>
					View Saved Reports
				</Button>
			</div>
		}
	>
		<div className={styles.title}>Report Saved</div>
		<div className={styles.description}>
			Your report template has been saved successfully and is ready to
			use.
		</div>
	</Modal>
);

export default ReportSavedModal;
